import styled from 'styled-components'

import { media } from 'styles/media'

export const Alert = styled.div`
  background-color: ${({ theme }) => theme['-ds-information-100'].value};
  padding: 30px;

  display: flex;
  flex-direction: column;
  border-radius: 8px;

  ${media.md`
    flex-direction: row;
    align-items: center;
    padding: 60px;
  `}
`

export const LogoWrapper = styled.div`
  flex-shrink: 0;
  align-self: baseline;
  margin: 0 0 24px 0;

  svg {
    width: 64px;
    height: 64px;
    color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  }

  ${media.md`
    margin: 0 24px 0 0;
  `}
`

export const ContentWrapper = styled.div`
  padding-right: 20px;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-weight: 400;
  margin: 0 0 24px 0;

  ${media.md`
    max-width: 70%;
    margin: 0;
  `}
`

export const Heading = styled.h4`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-size']?.value};

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-lg']?.['font-size']?.value};
  `}
`

export const Paragraph = styled.p`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-sm']?.['font-size']?.value};
  `}

  a {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    text-decoration: underline;
  }
`

export const ButtonWrapper = styled.div`
  ${media.md`
    margin-left: auto;
  `}
`
